import React from "react";
import "./App.css";
import PulpayApp from "./pulpay/PulpayApp";

function App() {
  return <PulpayApp />;
}

export default App;
